import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ToastService } from '@desbank/components';
import { Environment } from '@desbank/core/src/lib/environment';
import { LoggedService } from '@desbank/core/src/lib/login';
import { StorageService } from '@desbank/core/src/lib/services/storage';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

  private readonly HTTP_ERROR_CODES = {
    UNKNOWN: 0,
    UNAUTHORIZED: 401,
    BAD_REQUEST: 400,
    SERVER_ERROR: 500,
  };

  private readonly TITLE_TEXT = 'Ops!';

  constructor(
    private storageService: StorageService,
    private loggedService: LoggedService,
    private toastService: ToastService,
    @Inject('environment') private env: Environment
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.insertToken(request))
      .pipe(
        catchError(this.handleResponseError.bind(this)),
      );
  }

  private insertToken(req: HttpRequest<any>): HttpRequest<any> {
    const auth = this.storageService.getSession(this.env.authKey);
    const token = auth ? auth.token : null;

    if (!token) {
      return req;
    }

    return req.clone({ setHeaders: { Authorization: `Bearer ${token}` }});
  }

  private getErrorText(error: any | any[]): string {
    let message = '';
    if (Array.isArray(error)) {
      error.map((item: any) => {
        message += item.message + '<br>';
      });
    } else {
      message = error.message || 'Ocorreu um erro inesperado, tente novamente mais tarde!';
    }

    return message;
  }

  private handleResponseError(error: HttpErrorResponse): Observable<any> {
    switch (error.status) {
      case this.HTTP_ERROR_CODES.UNAUTHORIZED:
        this.toastService.addDangerMessage({
          title: this.TITLE_TEXT,
          subTitle: 'Verifique o usuário e senha ou logue novamente'
        });

        this.loggedService.dispatchExpiredSession();

        return throwError(error);

      case this.HTTP_ERROR_CODES.SERVER_ERROR:
        this.handleToasts(error);
        return throwError(error);

      case this.HTTP_ERROR_CODES.BAD_REQUEST:
        if (error.error) {
          this.handleToasts(error);
          
          return throwError(error);
        }

        this.toastService.addDangerMessage({
          title: this.TITLE_TEXT,
          subTitle: this.getErrorText(error.error)
        });

        return throwError(error);

      default:
        return throwError(error);
    }
  }

  private handleToasts(error: HttpErrorResponse): void {
    if (error.error && error.error.length > 0) {
      error.error.map((item: any) => {
        switch (item.type) {
            case 0:
                this.toastService.addSuccessMessage({
                    title: 'Mensagem do Sistema',
                    subTitle: this.getErrorText(item.messageList)
                });
                return;
            case 1:
                this.toastService.addWarningMessage({
                    title: 'Atenção!',
                    subTitle: this.getErrorText(item.messageList)
                });
                return;
            case 2:
                this.toastService.addDangerMessage({
                    title: this.TITLE_TEXT,
                    subTitle: this.getErrorText(item.messageList)
                });
                return;
            default:
                return;
        }
      });
    } else {
      this.toastService.addDangerMessage({
        title: this.TITLE_TEXT,
        subTitle: 'Ocorreu um erro inesperado, por favor tente novamente mais tarde!'
      });
    }
  }
}
